module.exports = __webpack_public_path__ + "img/6.27076a73.png";